import { render, staticRenderFns } from "./PickupAndDelivery.vue?vue&type=template&id=6e87d5fa&scoped=true"
import script from "./PickupAndDelivery.vue?vue&type=script&lang=js"
export * from "./PickupAndDelivery.vue?vue&type=script&lang=js"
import style0 from "./PickupAndDelivery.vue?vue&type=style&index=0&id=6e87d5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87d5fa",
  null
  
)

export default component.exports